import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Image from "next/image";
import TimerIcon from "../../public/images/icons/Time.svg";
import TimingsIcon from "../../public/images/icons/Timings.svg";
import darkTheme from '../../src/theme';
import { nanoid } from "nanoid";
import moment from "moment";

const lineUpCard = {
  borderTop: `1px dotted`,
  borderColor: `#2F2F2F`,
  paddingTop: darkTheme.spacing(2),
  marginTop: darkTheme.spacing(2),
  marginBottom: 2,
  '& h2': {
    fontSize: 20,
    color: darkTheme.palette.primary.title,         
    fontWeight: 500,
    textTransform: 'capitalize !important',
    marginBottom:darkTheme.spacing(0.5)
  }, 
  '& h5': {
        fontSize: 14,
        textTransform: 'capitalize',    
        color: darkTheme.palette.primary.dates,       
        fontWeight: 400,    
    },    
  '& h6': {
    fontSize: 14,
    color: darkTheme.palette.primary.location,
    textTransform: 'capitalize !important',
    backgroundColor: darkTheme.palette.background.secondary,
    display: 'inline-block',
    minWidth: 100,
    padding: '7px 15px',
    borderRadius: 20,
    marginRight: darkTheme.spacing(1),
    textAlign: 'center',
    fontWeight: 500,
    marginBottom: darkTheme.spacing(1),
    [darkTheme.breakpoints.down("md")]: {
      fontSize:12
    }
  },
};

function Timings({ data }) {    
  
  let daysStatus = data.offer_days;
  if (data.offer_days.indexOf('sun') > -1 &&
      data.offer_days.indexOf('mon') > -1 &&
      data.offer_days.indexOf('tue') > -1 &&
      data.offer_days.indexOf('wed') > -1 &&
      data.offer_days.indexOf('thu') > -1 &&
      data.offer_days.indexOf('fri') > -1 &&
      data.offer_days.indexOf('sat') > -1) {
        daysStatus = 'All Days'
    }else if(data.offer_days.indexOf('sun') > -1 &&    
      data.offer_days.indexOf('sat') > -1) {
        daysStatus = 'Week Ends'
    }else if(data.offer_days.indexOf('mon') > -1 &&
      data.offer_days.indexOf('tue') > -1 &&
      data.offer_days.indexOf('wed') > -1 &&
      data.offer_days.indexOf('thu') > -1 &&
      data.offer_days.indexOf('fri') > -1) {
        daysStatus = 'Week Days'
    }

  return (
    <>           
      <Typography component="div" sx={lineUpCard}>
        <Typography variant="h5" sx={{ mb: 1 }}>Deal Applicable on</Typography> 
         <Typography component="p" sx={{color: darkTheme.palette.primary.location, fontSize: 18, fontWeight: 400}}>
              <Image
                  src={TimingsIcon}
                  alt=""
                  width={22}
                  height={22}
                  layout="fixed"
              />&nbsp;{data.start_time.slice(0, 5)} - {data.end_time.slice(0, 5)} Hrs Onwards |&nbsp; 
              {daysStatus == 'All Days' || daysStatus == 'Week Days' || daysStatus == 'Week Ends' ? (
                <>{daysStatus}</>
              ):(
                <>
                {daysStatus.split(",").map((item, i) => (
                  <span style={{textTransform:'capitalize'}}>
                      {item}
                      {i < daysStatus.split(",").length - 1 ? "," : ""}{" "}
                  </span>
                ))}
                </>
              )} 
          </Typography>
      </Typography>              
    </>
  );
}

export default Timings;
